var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import HeaderTitle from "./HeaderTitle";
var ResponsiveFlex = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.desktop(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: ", ";\n  "], ["\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: ", ";\n  "])), theme.spacing.two);
});
var AdminHeader = function (props) {
    var title = props.title, count = props.count, children = props.children;
    return (React.createElement(ResponsiveFlex, null,
        React.createElement(HeaderTitle, { title: title, count: count }),
        React.createElement("div", null, children)));
};
export default AdminHeader;
var templateObject_1, templateObject_2;
